import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { QueryEntity } from '../types';
import { PermissionOverride } from '../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useUpdatePermissionOverride = (matterId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<PermissionOverride, Error, { overrideId: string; roleId: string }>({
    mutationFn: async ({ overrideId, roleId }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: { roleId },
      });
      const response = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/permission-overrides/${overrideId}`,
        fetchConfig,
      );
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message ?? 'Failed to update Matter-level permission');
      }
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.PermissionOverrides, { matterId }]);
      toast.success('Matter-level permission updated');
    },
    onError: () => {
      toast.error('Failed to update Matter-level permission');
    },
  });
};
